import { Component } from '@grafikr/components';
import { NonNullish } from 'utils/nullish-check';
import updateQuickBuy from 'utils/quick-buy';

export default Component((node, { onMounted, app }) => {
  onMounted(() => {
    const quickBuy = node.querySelector('[data-quick-buy]');

    if (quickBuy) {
      quickBuy.addEventListener('click', async () => {
        const template = NonNullish(
          node.querySelector<HTMLTemplateElement>(
            'template[data-subscription-form]'
          ),
          'Missing quick buy template'
        );

        updateQuickBuy(template, () => {
          app.mount();
          document.dispatchEvent(new CustomEvent('quick-buy-open'));
        });
      });
    }
  });
});
